var map = {
	"./category-img-1.jpg": 17208,
	"./category-img-2.jpg": 97191,
	"./category-img-3.jpg": 29450,
	"./category-img-4.jpg": 66169,
	"./category-img-5.jpg": 79292,
	"./slider-01.jpg": 49327,
	"./slider-02.jpg": 66336
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6666;